module.exports = __webpack_public_path__ + "media/img/frontend_application/bottomnav/search-538cd5209eb835d8c7e499faece981b0.svg";